export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const addToBasket = item => ({
    type: ADD_TO_BASKET,
    payload: item,
});

export const ADD_COUPON = 'ADD_COUPON';
export const addCoupon = coupon => ({
    type: ADD_COUPON,
    payload: coupon,
});

export const ADD_COUPON_FULFILLED = 'ADD_COUPON_FULFILLED';
export const addCouponFulfilled = () => ({
    type: ADD_COUPON_FULFILLED,
});

export const ADD_COUPON_REJECTED = 'ADD_COUPON_REJECTED';
export const addCouponRejected = () => ({
    type: ADD_COUPON_REJECTED,
});

export const ADD_COUPON_GET_DISCOUNT = 'ADD_COUPON_GET_DISCOUNT';
export const getDiscount = () => ({
    type: ADD_COUPON_GET_DISCOUNT
});

export const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET';
export const removeFromBasket = plan_id => ({
    type: REMOVE_FROM_BASKET,
    payload: plan_id,
});

export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const fetchSubscriptions = () => ({ type: FETCH_SUBSCRIPTIONS });

export const FETCH_SUBSCRIPTIONS_FULFILLED = 'FETCH_SUBSCRIPTIONS_FULFILLED';
export const fetchSubscriptionsFulfilled = subscriptions => ({
    type: FETCH_SUBSCRIPTIONS_FULFILLED,
    payload: subscriptions,
});

export const PRICING_PAYMENT = 'PRICING_PAYMENT';
export const pricingPayment = paymentPayload => ({
    type: PRICING_PAYMENT,
    payload: paymentPayload,
});

export const PRICING_PAYMENT_FULFILLED = 'PRICING_PAYMENT_FULFILLED';
export const pricingPaymentFulfilled = () => ({
    type: PRICING_PAYMENT_FULFILLED,
});

export const PRICING_PAYMENT_REJECTED = 'PRICING_PAYMENT_REJECTED';
export const pricingPaymentRejected = () => ({
    type: PRICING_PAYMENT_REJECTED,
});
